module.exports = "/_next/static/images/338959244a47035691555a66aacb978d-double-card@sm-1x.png.webp";